import { Button, Dialog, DialogContent, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";
import { ErrorOutline as ErrorIcon } from "@mui/icons-material";
import { useForm } from "../../../providers/FormProvider";

const useStyles = makeStyles()(
  (theme) => ({
    checkCircle: {
      width: "108px",
      height: "108px",
      color: theme.palette.error.main
    },
    button: {
      "@media (max-width: 500px)": {
        padding: theme.spacing(3.5)
      }
    }
  })
);

export default function SubmitErrorDialog() {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const {
    copyForm,
    makeNewEmptyForm,
  } = useForm();

  return (
    <Dialog
      open
      maxWidth="xs"
      fullWidth
    >
      <DialogContent>
        <Stack alignItems="center" spacing={1.5} padding={3.5}>

          <ErrorIcon className={classes.checkCircle} />

          <Typography variant="h6" textAlign="center">{t("submitErrorDialog:title")}</Typography>

          <Typography variant="body1" textAlign="center">
            {t("submitErrorDialog:description")}
          </Typography>

          <Button variant="contained" fullWidth size="large" color="neutral" onClick={makeNewEmptyForm} className={classes.button}>
            {t("submitErrorDialog:newEmpty")}
          </Button>

          <Button variant="contained" fullWidth size="large" color="neutral" onClick={copyForm} className={classes.button}>
            {t("submitErrorDialog:copy")}
          </Button>

        </Stack>
      </DialogContent>
    </Dialog >
  );
}